<script>
import ProInput from '$common/ProInput'
export default {
  name: 'Invoice',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    },
  },
  data () {
    return {
      message: '',
      amount: 0,
    }
  },
  methods: {
    async onSubmit() {
      console.log('submit')
      if (this.amount <= 0) return this.$toast('Amount must be greater than 0')
      this.$toast('Sending...')
      try {
        await this.$HTTP({
          method: 'post',
          uri: `users/${this.options.guardian.id}/send-invoice`,
          body: {
            amount: this.amount,
            message: this.message,
            guardian: this.options.guardian,
            origin: location.origin,
          },
        })
        this.$toast('Invoice sent.')
        this.$modals.hide('invoice')
      } catch (e) {
        console.log(e)
        this.$toast('Could not send invoice.')
      }
    },
  },
}
</script>

<template lang="pug">
  #invoice-main.modal-main
    .invoice-container.modal-container
      .title Send Invoice
      .content
        .description This will send an invoice to 
          b {{options.guardian.name}} 
          | at 
          b {{options.guardian.email}} 
          | for the amount specified.
        .pro-form
          .form-row
            pro-input(
              v-model='amount'
              :options='{title: "Amount", name: "amount", type: "number"}'
            )
            .title Message:
            pro-input(
              v-model='message'
              :options='{title: "Message", name: "message", type: "textarea"}'
            )
      
      .action
        .button.minor(
          @click='$modals.hide(`invoice`)'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) Send Invoice
 </template>

 <style lang="sass" scoped>

 </style>